import React from "react";
import { useSdkContext } from "~/components/contexts";
import { SubscriptionButtonContainer } from "~/components/rosetta/subscription-button/styles";
import { AutoRenewButton } from "./auto-renew-button";
import { EpaperButton } from "./epaper-button";
import { GracePeriodButton } from "./grace-period-button";
import { ReactivateButton } from "./reactivate-button";
import { RenewButton } from "./renew-button";
import { SubscribeButton } from "./subscribe-button";
import { UpgradeButton } from "./upgrade-button";
export const SubscriptionButton = ({
  className,
  location = "masthead",
  variant
}) => {
  const {
    rosettaInstance
  } = useSdkContext();
  const mastheadButtonType = rosettaInstance === null || rosettaInstance === void 0 ? void 0 : rosettaInstance.rulesEngine.getOutcome("ui.masthead.buttonTypeWithEpaper");
  const handlerRenderButton = () => {
    switch (mastheadButtonType) {
      case "AUTORENEW":
        return /*#__PURE__*/React.createElement(AutoRenewButton, {
          className: className
        });
      case "GRACEPERIOD":
        return /*#__PURE__*/React.createElement(GracePeriodButton, {
          className: className
        });
      case "REACTIVATE":
        return /*#__PURE__*/React.createElement(ReactivateButton, {
          className: className,
          location: location
        });
      case "RENEW":
        return /*#__PURE__*/React.createElement(RenewButton, {
          className: className
        });
      case "SUBSCRIBE":
        return /*#__PURE__*/React.createElement(SubscribeButton, {
          className: className,
          location: location
        });
      case "UPGRADE":
        return /*#__PURE__*/React.createElement(UpgradeButton, {
          className: className
        });
      case "EPAPER":
        return /*#__PURE__*/React.createElement(EpaperButton, {
          className: className
        });
      default:
        return null;
    }
  };
  return /*#__PURE__*/React.createElement(SubscriptionButtonContainer, {
    $variant: variant,
    "data-qa": "subscription-button"
  }, handlerRenderButton());
};
SubscriptionButton.displayName = "SubscriptionButton";